<template>
  <div class="addPaper">
    <div class="addPaper_head"  v-if="resourcesFrom == '1'">
         <span></span>
        <el-input
          @keyup.enter.native="inputSearch"
          style="width: 190px"
          v-model="name"
          size="mini"
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          clearable
          @clear="inputSearch"
        ></el-input>
    </div>
    <div style="flex: 1;position: relative">
      <el-table
        :data="questionList"
        style="position: absolute"
        @row-click="rowClick"
        :height="`calc(100% - 80px)`"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
      >
        <el-table-column label width="35">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="currentValue">&nbsp;</el-radio>
          </template>
        </el-table-column>

        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width || 'auto'"
          :fixed="item.fixed ? item.fixed : false"
          :show-overflow-tooltip="item.showOverflow ? item.showOverflow : false"
          :align="item.align ? item.align : 'center'"
        >
          <template slot-scope="scope">
            <div
              v-if=" item.prop != 'operation'"
              :title="scope.row[item.prop]"
              v-text="scope.row[item.prop]"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              style="color: #1890FF;"
              @click.native.prevent="previewBtn(scope.row,scope.$index)"
            >
              预览
            </el-button>
          </template>
        </el-table-column>

        <div slot="empty" class="empty_material">
          <p>暂无作业</p>
        </div>
      </el-table>
      <Pagination
        style="position: absolute;bottom: 0;right: 0"
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
      ></Pagination>
    </div>

    <!-- 弹窗 -->
    <n-dialog
      :title="'提示'"
      :dialogVisible="addTestPaperShow"
      :width="'400px'"
      :dialogType="dialogType"
      :deleteNum="'1'"
      :deleteName="deleteName"
      :isDedicated="isDedicated"
      @conformFunc="conformFunc"
      @closeDialog="closeDialog"
    ></n-dialog>

    <!-- 作业预览 -->
    <create-work
      v-show="isShowCreateWorkDialog"
      :isShowCreateWorkDialog="isShowCreateWorkDialog"
      :dialogData="dialogData"
      :isNotEdit="isNotEdit"
      dialogTitle="预览作业模版"
      :append-to-body="true"
      @handleClose="closeDialogWork"
    ></create-work>

  </div>
</template>
<script>
import * as api from "../../api/courseApi";
import * as sourceApi from "../../api/sourceApi";
import * as workApi from '../../api/work'
import Pagination from "@/components/paginator/paginator";
import CreateWork from "../szrt_revision/teachingDetail/components/CreateWork.vue"
export default {
  name: "addQuestion.vue",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    },
    courseId: {
      type: [String, Number],
      default: 0,
    },
    resourcesFrom: {
      type: String,
      default: '',
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    addType: {
      type: [String, Number],
      default: -1,
    },
    type: {
      type: [String, Number],
      default: -1,
    },
  },
  components: {
    Pagination,
    CreateWork
  },
  data() {
    return {
      currentValue: this.value,
      questionList: [],
      tableHeader: [
        {
          prop: "name",
          label: "作业模版名称",
          showOverflow: true,
          align: "left",
        },
      ],
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      name: "",
      resourceDatas: [],
      categoryId: "",
      // 删除弹窗
      dialogTitle: "",
      dialogType: "",
      deleteName: "",
      deleteDialog: {
        categoryResourceId: "",
        resourceId: "",
      },
      addTestPaperShow: false,
      isDedicated: true,
      // 作业模版预览
      isShowCreateWorkDialog: false,
      isNotEdit: false,
      dialogData: {}
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit("input", val);
    },
    resourcesFrom() {
      this.init();
    },
  },
  computed: {},
  created() {
    this.findResCategoryByCourseId();
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      if (this.resourcesFrom == '1'){
        this.postGetPaperByCourseId();
      }else{
        this.getWorkTemplate();
      }
    },
    //添加试题
    addQues(){
      let type = -1;
      if (this.type > -1) {
        type = this.type == 7 ? 7 : 4;
      } else if (this.addType > -1) {
        type = this.addType;
      }
      this.$emit('addQues',type)
    },
    // 获取作业模版列表
    postGetPaperByCourseId() {
      // let params = {
      //   courseId: this.courseId, //课程id
      //   categoryId: this.categoryId, //资源分类id
      //   name: this.name, //试题名称
      //   pageNum: this.pageTotal.currentPage,
      //   pageSize: this.pageTotal.pageSize,
      // };
      // api.postGetPaperByCourseId(params).then((res) => {
      //   if (res.code == 0) {
      //     this.questionList = res.data.list;
      //     this.pageTotal.total = res.data.total;
      //   }
      // });
      let obj = {
        name: this.name,
        pageNo: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        courseId: this.courseId ? this.courseId : this.$route.query.courseId,
        classId: this.$route.query.classId,
      };
      workApi.workTemplateList(obj).then(res=>{
        if(res.code == 0){
          this.questionList = res.data.list;
          this.pageTotal.total = res.data.total;
        }
      })
    },
    // 获取作业模版列表
    getWorkTemplate(){
      let obj = {
        subjectId: this.subjectId,
        pageNo: this.pageTotal.currentPage,
        pageSize: this.pageTotal.pageSize,
        courseId: this.courseId ? this.courseId : this.$route.query.courseId,
        classId: this.$route.query.classId,
      };
      workApi.workTemplateList(obj).then(res=>{
        if(res.code == 0){
          this.questionList = res.data.testPaperList;
          this.pageTotal.total = res.data.totalCount;
        }
      })
    },
    inputSearch() {
      this.pageTotal.currentPage = 1;
      this.postGetPaperByCourseId();
    },
    // 查询资源分类
    findResCategoryByCourseId() {
      sourceApi
        .FindResCategoryByCourseId(this.courseId)
        .then((res) => {
          if (res.code == "0") {
            this.resourceDatas = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val || this.pageTotal.currentPage;
      this.postGetPaperByCourseId();
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.postGetPaperByCourseId();
    },
    rowClick(row) {
      this.currentValue = row.id;
      this.$emit('hhdTeacher', row);
    },
    initPageTotal() {
      this.$set(this.pageTotal, "currentPage", 1);
    },
    // 预览
    previewBtn(row) {
      console.log(row);
      workApi.workTemplateGetById(row.id).then(res => {
        if (res.code == "0") {
          this.dialogData = res.data;
          this.isNotEdit = true
          this.isShowCreateWorkDialog = true;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    closeDialogWork() {
      this.isShowCreateWorkDialog = false
    },
    deleteBtn(row) {
      this.deleteName = row.paperName;
      this.deleteDialog.categoryResourceId = row.categoryResourceId;
      this.deleteDialog.resourceId = row.id;
      this.dialogWidth = "400px";
      this.dialogType = "deleteTestPaper";
      this.addTestPaperShow = true;
    },
    closeDialog() {
      this.deleteId = "";
      this.addTestPaperShow = false;
      // this.findPageResource();
    },
    conformFunc() {
      let params = {
        courseId: this.courseId, //课程id
        resourceId: this.deleteDialog.resourceId, // id
        categoryResourceId: this.deleteDialog.categoryResourceId
      };
      api.deleteFromCatalog(params).then(res => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.closeDialog();
          this.postGetPaperByCourseId();
        } else {
          this.$message.error(res.msg);
        }
      })
    }

  },
};
</script>

<style scoped lang="scss">
.addPaper {
  height: 100%;
  width: 100%;
  color: #2b2a33;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .addPaper_head {
    padding: 15px 0;
    /*line-height: 35px;*/
    display: flex;
    justify-content: space-between;
    .search_item {
      width: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/component/addWork.vue